var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterFunnel01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter-funnel-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.66699 3.83333C1.66699 3.36662 1.66699 3.13327 1.75782 2.95501C1.83771 2.79821 1.9652 2.67072 2.122 2.59083C2.30026 2.5 2.53362 2.5 3.00033 2.5H17.0003C17.467 2.5 17.7004 2.5 17.8787 2.59083C18.0355 2.67072 18.1629 2.79821 18.2428 2.95501C18.3337 3.13327 18.3337 3.36662 18.3337 3.83333V4.39116C18.3337 4.61516 18.3337 4.72716 18.3063 4.8313C18.282 4.92359 18.2421 5.01103 18.1882 5.0898C18.1275 5.17869 18.0428 5.25204 17.8736 5.39875L12.5438 10.0179C12.3745 10.1646 12.2898 10.238 12.2291 10.3269C12.1752 10.4056 12.1353 10.4931 12.111 10.5854C12.0837 10.6895 12.0837 10.8015 12.0837 11.0255V15.382C12.0837 15.5449 12.0837 15.6264 12.0574 15.6969C12.0342 15.7591 11.9964 15.8149 11.9472 15.8596C11.8916 15.9102 11.8159 15.9404 11.6646 16.001L8.83125 17.1343C8.52497 17.2568 8.37182 17.3181 8.24889 17.2925C8.14138 17.2702 8.04704 17.2063 7.98637 17.1148C7.91699 17.0101 7.91699 16.8452 7.91699 16.5153V11.0255C7.91699 10.8015 7.91699 10.6895 7.88962 10.5854C7.86537 10.4931 7.82544 10.4056 7.77158 10.3269C7.71081 10.238 7.62617 10.1646 7.4569 10.0179L2.12708 5.39875C1.95781 5.25204 1.87318 5.17869 1.8124 5.0898C1.75855 5.01103 1.71862 4.92359 1.69436 4.8313C1.66699 4.72716 1.66699 4.61516 1.66699 4.39116V3.83333Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFunnel01);
export default __webpack_public_path__ + "static/media/filter-funnel-01.1d880a10c55b18799c95b95ae9b7380c.svg";
export { ForwardRef as ReactComponent };